const ProfileId = Object.freeze({
  WAITRESS: 4,
});

export const isWaitress = (profileId) => profileId === ProfileId.WAITRESS;
